"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_css_1 = __importDefault(require("dom-css"));
var scrollbarWidth = undefined;
function getScrollbarWidth() {
    if (typeof scrollbarWidth === 'number')
        return scrollbarWidth;
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        dom_css_1.default(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar',
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}
exports.default = getScrollbarWidth;
